import addToMonthlyCostArr from "../objectsHome/add_to_monthly_cost_arr";

export const buildMonthlyCarAmtsArr = (currentCar, newCar) => {
   
        let monthlyCostArr = [];
        let totalCurrentMonthlyCost = 0;
        let totalNewMonthlyCost = 0;
        addToMonthlyCostArr("Monthly Loan Payment", currentCar.loanAmt,
            newCar.loanAmt, 1, "red", monthlyCostArr);
        addToMonthlyCostArr("Auto Insurance", currentCar.autoInsAmt, newCar.autoInsAmt, 2, "red",
            monthlyCostArr)  
        if (currentCar.busPassAmt !==0 || newCar.busPassAmt !== 0){
            addToMonthlyCostArr("Bus Pass", currentCar.busPassAmt, newCar.busPassAmt, 3, "red", monthlyCostArr);
        }
        totalCurrentMonthlyCost = +currentCar.loanAmt + +currentCar.autoInsAmt;
        totalNewMonthlyCost = +newCar.loanAmt + +newCar.autoInsAmt + +newCar.busPassAmt;
        addToMonthlyCostArr("Total Car Monthly Costs: ", totalCurrentMonthlyCost, totalNewMonthlyCost, 4, "red",
            monthlyCostArr)
        monthlyCostArr.sort((a, b) => (a.order > b.order) ? 1 : -1);
        return monthlyCostArr;
}
export default buildMonthlyCarAmtsArr;
